import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-company-details-card",
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterLink],
  templateUrl: "./company-details-card.component.html",
  styles: [":host { display: block; height: 100%; }"],
})
export class CompanyDetailsCardComponent {
  @Input() company: { id?: string; _id?: string; name?: string } | null = null;
  @Input() logoUrl: string | null = null;

  openLogo(event: Event) {
    event.stopPropagation();
    if (this.logoUrl)
      window.open(this.logoUrl, "_blank", "noopener,noreferrer");
  }
}
